import { ReactElement } from 'react';
import styles from './Header.module.scss';

interface IHeaderProps {
  icon: ReactElement;
  name: string;
  color: 'yellow' | 'blue' | 'violet' | 'green' | 'red' | 'orange';
}

const Header = ({ icon, name, color }: IHeaderProps) => {
  const getClassName = () => {
    switch (color) {
      case 'yellow':
        return styles.Yellow;
      case 'violet':
        return styles.Violet;
      case 'green':
        return styles.Green;
      case 'red':
        return styles.Red;
      case 'orange':
        return styles.Orange;
      default:
        return styles.Blue;
    }
  };

  return (
    <div className={styles.Header}>
      <div className={`${styles.Icon} ${getClassName()}`}>{icon}</div>
      <span className={styles.Title}>{name}</span>
    </div>
  );
};

export default Header;
